import { addIntegralOper } from '../../api/home'

export function debounce(func, delay) {
	var delay = delay || 200;
	let timer
	return function (...args) {
		if (timer) {
			clearTimeout(timer)
		}
		timer = setTimeout(() => {
			func.apply(this, args)
		}, delay)
	}
}


export function throttle(fn, delay = 100) {
	var lock = false;
	return (...args) => {
		if (lock) return;
		fn(...args);
		lock = true;
		setTimeout(() => { lock = false }, delay)
	}
}

export function clickToBack(_this, n = -1) {

	_this.$router.go(n);

}

export function browserMobile() {
		var ua = window.navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isChrome = /(?:Chrome|CriOS)/.test(ua),
		isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
		isPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isPc = !isPhone && !isAndroid && !isSymbian;
	return {
		isTablet: isTablet,
		isPhone: isPhone,
		isAndroid: isAndroid,
		isPc: isPc
	};

}

// 积分
export function addIntegral(data){
	addIntegralOper(data).then(res=>{
		data = res.entity
	})
}


// WEBPACK FOOTER //
// ./src/common/js/util.js